/* eslint-disable
    consistent-return,
    import/no-mutable-exports,
    no-inner-declarations,
    no-return-assign
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import $ from 'jquery';

import * as browser from 'lib/Browser';
import {noop} from '@benchling/js-utils';

let defaultExport = {};
if (!browser.isBrowser) {
  defaultExport = {
    push: noop,
    pop: noop,
    getManager: () => ({
      push: noop,
      pop: noop,
      isActive() {
        return false;
      },
    }),
    isActive() {
      return false;
    },
  };
} else {
  const invalidFile = (e) => !e.originalEvent.dataTransfer.types.includes('Files');

  // Rule of thumb: if the drag/drop event already has default prevented, a child is trying to handle the
  // drag-and-drop, so we should silently ignore the event or clean up the (dragging) state.

  function getManager(container, target = null) {
    target = target || container;
    const $target = $(target);
    const $container = $(container);

    // Return the manager if it's already been defined.
    if ($container.data('dragdrop-manager') != null) {
      return $container.data('dragdrop-manager');
    }

    // Otherwise, create a new manager and register events.
    let THE_STACK = [];
    let DRAG_COLLECTION = $();

    const manager = {
      push(el) {
        return THE_STACK.push(el);
      },
      pop(el) {
        return (THE_STACK = THE_STACK.filter((stackEl) => stackEl !== el));
      },
      isActive() {
        return THE_STACK.length > 0;
      },
    };
    $container.data('dragdrop-manager', manager);

    $target.on('drop', (e) => {
      if (e.isDefaultPrevented()) {
        return;
      }
      e.stopPropagation();
      e.preventDefault();
      if (THE_STACK.length > 0) {
        const topEl = THE_STACK[THE_STACK.length - 1];
        if (!invalidFile(e)) {
          $(topEl).trigger('filedrop', [e.originalEvent.dataTransfer.files]);
        }
        DRAG_COLLECTION = $();
      }
      $container.removeClass('dragging');
    });

    $target.on('dragover.dragdrop', (e) => {
      let effectAllowed;
      if (e.isDefaultPrevented()) {
        return;
      }
      e.stopPropagation();
      e.preventDefault();
      const {dataTransfer} = e.originalEvent;
      if (!dataTransfer) {
        return;
      }
      if (invalidFile(e) || THE_STACK.length === 0) {
        // Show no effect if dragging a non-file
        dataTransfer.dropEffect = 'none';
        return;
      }

      // IE10 and IE11 error if effectAllowed is accessed during dragover (which is fired repeatedly)
      try {
        ({effectAllowed} = dataTransfer);
        // eslint-disable-next-line benchlint/always-throw-from-catch
      } catch (error) {
        e = error;
        effectAllowed = null;
      }

      dataTransfer.dropEffect = (() => {
        switch (effectAllowed) {
          case 'move':
          case 'linkMove':
            return 'move';
          default:
            return 'copy';
        }
      })();
    });

    $target.on('dragenter.dragdrop', (e) => {
      if (e.isDefaultPrevented()) {
        DRAG_COLLECTION = $();
        $container.removeClass('dragging');
        return;
      }
      e.stopPropagation();
      const {dataTransfer} = e.originalEvent;
      // Not sure why, but sometimes dataTransfer is null on FF.
      // The dropEffect is optional anyways, just for visual look.
      if (dataTransfer == null) {
        return;
      }
      if (invalidFile(e) || THE_STACK.length === 0) {
        // Show no effect if dragging a non-file
        if (dataTransfer != null) {
          dataTransfer.dropEffect = 'none';
        }
        return;
      }
      if (DRAG_COLLECTION.size() === 0) {
        $container.addClass('dragging');
      }
      DRAG_COLLECTION = DRAG_COLLECTION.add(e.target);
      if (dataTransfer != null) {
        dataTransfer.dropEffect = 'copy';
      }
    });

    $target.on('dragleave.dragdrop', (e) => {
      if (e.isDefaultPrevented()) {
        return;
      }
      e.stopPropagation();
      setTimeout(() => {
        DRAG_COLLECTION = DRAG_COLLECTION.not(e.target);
        if (DRAG_COLLECTION.size() === 0) {
          return $container.removeClass('dragging');
        }
      });
    });

    return manager;
  }

  // Setup global body/window manager.
  const DIV_LEFT = $('<div class="drop-emphasis left">');
  const DIV_TOP = $('<div class="drop-emphasis top">');
  const DIV_RIGHT = $('<div class="drop-emphasis right">');
  const DIV_BOTTOM = $('<div class="drop-emphasis bottom">');
  $('body').append(DIV_LEFT).append(DIV_TOP).append(DIV_RIGHT).append(DIV_BOTTOM);

  const windowManager = getManager(document.body, window);

  defaultExport = {
    push: windowManager.push,
    pop: windowManager.pop,
    getManager,
    isActive: windowManager.isActive,
  };
}
export default defaultExport;
